<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <slot />
      </v-col>

      <feed-card2
        v-for="(article, i) in paginatedArticles2"
        :key="article.title"
        :size="layout[i]"
        :value="article"
      />
    </v-row>

    <v-row align="center">
      <v-col cols="3">
        <base-btn
          v-if="page !== 1"
          class="ml-0"
          square
          title="Previous page"
          @click="page--"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </base-btn>
      </v-col>

      <v-col
        class="text-center subheading"
        cols="6"
      >
        strona {{ page }} z {{ pages }}
      </v-col>

      <v-col
        class="text-right"
        cols="3"
      >
        <base-btn
          v-if="pages > 1 && page < pages"
          class="mr-0"
          square
          title="Next page"
          @click="page++"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </base-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'Feed2',

    components: {
      FeedCard2: () => import('@/components/FeedCard2'),
    },

    data: () => ({
      layout: [2, 2, 2, 2],
      page: 1,
    }),

    computed: {
      ...mapState(['articles2']),
      pages () {
        return Math.ceil(this.articles2.length / 4)
      },
      paginatedArticles2 () {
        const start = (this.page - 1) * 4
        const stop = this.page * 4

        return this.articles2.slice(start, stop)
      },
    },

  }
</script>
